module.exports = __webpack_public_path__ + "static/media/pop-up-on.62bc5a54.mp3";